import { useCanAccessPremium } from '@/hooks/billing/useCanAccessPremium'
import { useIsTrialPeriod } from '@/hooks/billing/useIsTrialPeriod'

/**
 * Returns whether the current user can access Federal Award AI and recipient search.
 *
 * This does not gate the other Federal Market Intelligence flyout items
 * (vehicles, forecasts, protests), which use the vehicles entitlement.
 *
 * Granted to premium/enterprise users and users in an active free trial.
 */
export const useCanAccessAwardRecipientSearch = () => {
  const { canAccessPremium, isLoading: isLoadingPremium } =
    useCanAccessPremium()
  const { isTrialPeriod, isLoading: isLoadingTrial } = useIsTrialPeriod()

  return {
    canAccessAwardRecipientSearch: canAccessPremium || isTrialPeriod,
    isLoading: isLoadingPremium || isLoadingTrial,
  }
}
